import validate from "/usr/src/app/content/n3-spas-891434cc-a2a9-466d-a95d-f553739de5f5/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-891434cc-a2a9-466d-a95d-f553739de5f5/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}